var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('div',{staticClass:"headerOne"},[_c('img',{attrs:{"src":require("../../assets/images/returnOne.png")},on:{"click":function($event){_vm.$router.go(-1)}}}),_vm._v(" "),_c('span',{staticClass:"buss"},[_vm._v("选择出生日期")])])]),_vm._v(" "),_c('button',[_vm._v("选择")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-263d39ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/change/birthday.vue
// module id = null
// module chunks = 